/* Mapping between the shell's internal `view` objects and vue-router 3 locations. */
export function viewToRoute(v) {
  switch (v.name) {
    case 'indicators': return { name: 'dashboard-indicators', hash: v.hash ? '#' + v.hash : '', query: Object.assign({}, v.year ? { year: String(v.year) } : {}, v.metric && v.metric !== 'part' ? { metric: v.metric } : {}) }
    case 'surveys': return { name: 'dashboard-surveys' }
    case 'survey': return { name: 'dashboard-survey', params: { id: String(v.id) } }
    case 'strategic': return { name: 'dashboard-strategic' }
    case 'compare': return { name: 'dashboard-compare', query: v.query || {} }
    default: return { name: 'dashboard' }
  }
}
export function routeToView(route) {
  switch (route.name) {
    case 'dashboard-indicators': return { name: 'indicators', hash: (route.hash || '').replace(/^#/, '') || null, year: route.query.year ? +route.query.year : null, metric: route.query.metric || 'part' }
    case 'dashboard-surveys': return { name: 'surveys' }
    case 'dashboard-survey': return { name: 'survey', id: +route.params.id }
    case 'dashboard-strategic': return { name: 'strategic' }
    case 'dashboard-compare': return { name: 'compare', query: route.query || {} }
    default: return { name: 'exec' }
  }
}
